
const getDropdownLabel = (dropdownData) => dropdownData.get('dropdownLabel');
const getOptionsData = (dropdownData) => dropdownData.get('options');
const isAnswered = (localAnswer) => !!localAnswer;

export {getDropdownLabel, getOptionsData, isAnswered}